// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a91781e0","513":"eb1d1225","703":"8e398371","885":"3407f866"}[chunkId] + ".chunk.js";
};